import styled from 'styled-components';
import { colors } from '../colors';

const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	color: ${colors.BlueBase};
	button {
		background: transparent !important;
	}
	.user-info {
		display: flex;
		align-items: center;
		img {
			border-radius: 50%;
			width: 40px;
			height: 40px;
			margin-right: 14px;
		}
		span {
			color: #fff;
			font-size: 9px;
		}
	}
`;

export default HeaderRight;
